import { all } from "redux-saga/effects"
import LoginSaga from "./auth/login/saga"

export default function* rootSaga() {
    yield all([
        LoginSaga()
    ])
}